import type { MarketingPreferencesState, MarketingPreferencesStore } from '../domain/types'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand'

const defaultInitialState: MarketingPreferencesState = {
  savePreferences: {
    loading: false,
    error: false,
    success: false,
  },
}
export function createMarketingPreferencesStore(initialState: MarketingPreferencesState = defaultInitialState) {
  return createStore<MarketingPreferencesStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as MarketingPreferencesState)
    },
  }))
}

export const marketingPreferencesStore = createMarketingPreferencesStore()
